module.exports = __webpack_public_path__ + "static/media/contanuity-lite.10dedee5.png";